/* @flow */

import React, { useCallback } from 'react';

import Localizer from '../../helpers/localization';

export type FreeTrialButtonPropType = {
  +hasButton: boolean,
  +isRegisteredAsGuest: boolean,
  +url: string,
};

const FreeTrialButton = ({ hasButton, isRegisteredAsGuest, url }: FreeTrialButtonPropType): React.Node => {
  const onClickHandler = useCallback(() => window.location.assign(url), [url]);

  if (!isRegisteredAsGuest || !hasButton || url === '') {
    return null;
  }

  return (
    <button className='freeTrial' onClick={onClickHandler} type='button'>
      {Localizer.localize('subscription.start_free_trial_button')}
    </button>
  );
};

export default FreeTrialButton;
